import './Skills.scss'

export const Skills = ({ skill }: { skill: string }) => <div className="skill">{skill}</div>
